import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EventDto } from "../../../dtos/EventDto";

@Component({
  selector: 'app-event-detail',
  standalone: false,
  templateUrl: './app-event-detail.component.html',
  styleUrl: './app-event-detail.component.scss',
  host: {
    class: 'row flex-grow-1'
  }
})
export class EventDetailComponent implements OnInit {
 @Input() event: EventDto;

 constructor(private activatedRoute: ActivatedRoute) {}

 async ngOnInit() {
   this.activatedRoute.data.subscribe(({ event }) => {
     this.event = event;
   })
 }

  getDate(event: EventDto): string {
    return new Date(event.eventDate).toLocaleDateString()
  }

  getTime(event: EventDto): string {
    return new Date(event.eventDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
}